export const TC_BILLING_ISLEGACY = 'TC:billing:isLegacy'
export const TC_BILLING_SELECTEDCIDN = 'TC:billing:selectedCidn'
export const TC_BILLING_ACC_ID = 'TC:billing:accID'
export const TC_BILLING_SOURCE_SYSTEM = 'TC:billing:sourceSystem'
export const TC_BILLING_INVOICE_LIST_FILTER = 'TC:billing:invoiceListFilter';
